import Typography from '@alltrails/shared/denali/components/Typography';
import Button from '@alltrails/shared/denali/components/Button';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import Tent from '@alltrails/shared/illustrations/Tent';

import * as styles from './errors.module.scss';

const LegacyMap404Header = () => (
  <div className={styles.fullPage}>
    <div className={styles.contentContainer}>
      <Tent />
      <div className={styles.textContainer}>
        <Typography component="div" variant="heading400">
          <FormattedMessage defaultMessage="Content unavailable" />
        </Typography>
        <Typography color="secondary" component="div" variant="text200">
          <FormattedMessage defaultMessage="This content has either been removed or made private by its owner" />
        </Typography>
      </div>
      <Button
        linkInfo={{ href: '/explore/custom-routes/new' }}
        text={<FormattedMessage defaultMessage="Build your own route" />}
        testId="build-your-own-route-cta"
        variant="primary"
      />
    </div>
  </div>
);

export default LegacyMap404Header;
